export default __webpack_public_path__ + "static/media/warnning.42b39a0a.svg";